import React, { useState, useEffect, createContext, useContext, useCallback } from 'react';
import { getUser, signIn as sendSignInRequest } from '../api/auth';


function AuthProvider(props) {
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async function () {
      const result = await getUser();
      if (result.isOk) {
        setUser(result.data);
      }

      setLoading(false);
    })();
  }, []);

  const signIn = useCallback(async (email, password,is_group_client_contact_person) => {
    const result = await sendSignInRequest(email, password,is_group_client_contact_person);
    if (result.isOk) {
      setUser(result.data);
    }

    return result;
  }, []);

  const signOut = useCallback(() => {
    setUser(undefined);
  }, []);


  return (
    <AuthContext.Provider value={{ user, signIn, signOut, loading }} {...props} />
  );
}

const AuthContext = createContext({ loading: false });
const useAuth = () => useContext(AuthContext);
// const useAuth = () => {
//   const authContext = useContext(AuthContext);

//   // Function to clear localStorage
//   const clearLocalStorage = () => {
//       localStorage.clear();
//   };

//   // Call the clearLocalStorage function when useAuth is invoked
//   clearLocalStorage();

//   return authContext;
// };


export { AuthProvider, useAuth }
